import {
  Collapse,
  Button,
  Card,
  ControlGroup,
  Elevation,
  InputGroup,
  NumericInput,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, indianRupee } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import { withRouter } from "react-router";
import AsyncSelWrap from "../utils/AsyncSelWrap";

class SxLineItems extends React.Component {
  state = {
    collapsed: true,
    /** PANEL SEARCH */
    panelSearching: false,
    panelSearchResults: [],
    panelSelectedItem: null,
    sxLineItemSearching: false,
    sxLineItemSearchResults: [],
    sxLineItemSelectedItem: null,
    anSearching: false,
    anSearchResults: [],
    anSelectedItem: null,
    bedSearching: false,
    bedSearchResults: [],
    bedSelectedItem: null,
    isWaitingOnLineItem: false,
    panelTPASearching: false,
    panelTPASearchResults: [],
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      if (apiUrl === "sxPriceMaster") {
        if (this.props.data.chosenPanelInfo?.isCashless === true) {
          payload["panelName"] = this.props.data.chosenPanelName;
        }

        payload["panelSite"] = this.props.data.site;
      }
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/${apiUrl}/search`,
        payload
      );
      let results = [];
      // if (apiUrl === "sxPriceMaster") {
      //   for (var i = 0; i < res.length; i++) {
      //     let current = res[i];
      //     let flag = false;
      //     for (var j = 0; j < current.panels.length; j++) {
      //       if (current.panels[j].elementId === this.props.data.chosenPanelId) {
      //         flag = true;
      //       }
      //     }
      //     if (flag) {
      //       results.push(current);
      //     }
      //   }
      // } else {
      results = res;
      // }
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey]?.map((each) => {
            if (searchApiUrl === "sxBedMaster") {
              return {
                ...each,
                item: `${each.bed} - ${each.ward}`,
                entityTypeString: indianRupee(each.ratePaise),
              };
            }
            if (searchApiUrl === "sxPaymentPanelMaster") {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: `${each.contents.length} checks`,
              };
            }
            if (searchApiUrl === "sxTPAMaster") {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: each.entityType,
              };
            }
            if (searchApiUrl === "sxPriceMaster") {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: _.truncate(
                  each.sxStepIds.map((x) => x.elementName).join(", "),
                  { length: 20 }
                ),
                helper: _.truncate(
                  each.items.map((x) => x.elementName).join(", "),
                  { length: 20 }
                ),
              };
            }
            if (searchApiUrl === "sxAnaesthesiaPriceMaster") {
              return {
                ...each,
                item: each.anaesthesiaType,
                entityTypeString: indianRupee(each.ratePaise),
                helper: each.site,
              };
            }
            return null;
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={async (chosenItem) => {
            if (searchApiUrl === "sxBedMaster") {
              if (chosenItem.site !== this.props.data.site) {
                cogoToast.error(
                  "This bed/ward is not available for this site."
                );
                return;
              }

              this.props.onUpdate({
                totalBillAmountPaise:
                  this.props.data.totalBillAmountPaise + chosenItem.ratePaise,
                lineItems: [
                  ...this.props.data.lineItems,
                  {
                    ...chosenItem,
                    lineItemType: "BED",
                    originalRate: chosenItem.ratePaise,
                    rateChanged: false,
                    removedAfterBooking: false,
                    addedAfterBooking: false,
                    quantity: 1,
                    sxStepIds: [],
                    items: [],
                  },
                ],
              });
            }
            if (searchApiUrl === "sxAnaesthesiaPriceMaster") {
              if (chosenItem.site !== this.props.data.site) {
                cogoToast.error(
                  "This anaesthesia is not available for this site."
                );
                return;
              }
              this.props.onUpdate({
                totalBillAmountPaise:
                  this.props.data.totalBillAmountPaise + chosenItem.ratePaise,

                lineItems: [
                  ...this.props.data.lineItems,
                  {
                    ...chosenItem,
                    lineItemType: "ANAESTHESIA",
                    originalRate: chosenItem.ratePaise,
                    rateChanged: false,
                    removedAfterBooking: false,
                    addedAfterBooking: false,
                    quantity: 1,
                    sxStepIds: [],
                    items: [],
                  },
                ],
              });
            }
            if (searchApiUrl === "sxPaymentPanelMaster") {
              this.props.onUpdate({
                chosenPanelId: chosenItem._id,
                chosenPanelName: chosenItem.entityName,
                patientPanelPolicyNumber: "",
                chosenPanelInfo: chosenItem,
              });
            }
            if (searchApiUrl === "sxTPAMaster") {
              this.props.onUpdate({
                chosenTPAId: chosenItem._id,
                chosenTPAName: chosenItem.entityName,
              });
            }
            if (searchApiUrl === "sxPriceMaster") {
              this.setState({ isWaitingOnLineItem: true });
              // First check if already added.
              let alreadyAdded = this.props.data.lineItems;
              let alreadyAddedIndex = _.findIndex(
                alreadyAdded,
                (v) => v._id === chosenItem._id
              );
              if (alreadyAddedIndex > -1) {
                cogoToast.error("You have already added this.");
                this.setState({ isWaitingOnLineItem: false });
                return;
              }
              // Then Get Sx Steps
              let sxStepIdsInThisItem = chosenItem.sxStepIds.map(
                (s) => s.elementId
              );
              let sxStepsAlreadyIds = this.props.data.sxSteps.map((t) => t._id);
              let getSxStepsIdsArray = _.difference(
                sxStepIdsInThisItem,
                sxStepsAlreadyIds
              );
              let sxStepsLoaded = await Promise.all(
                getSxStepsIdsArray.map((x) => {
                  return apiCallPost(
                    `/meta-sx/${this.props.authStore.prefix}/getSxSteps`,
                    { _id: x }
                  );
                })
              ).catch((err) => {
                this.setState({ isWaitingOnLineItem: false });
                cogoToast.error(
                  "There was an error in loading the Sx Steps. Please check the console for more details."
                );
                return;
              });
              let flattenedSxStepsArray = _.flatten(sxStepsLoaded);
              let payloadObj = {};
              if (flattenedSxStepsArray.length > 0) {
                payloadObj = {
                  sxSteps: [
                    ...this.props.data.sxSteps,
                    ...flattenedSxStepsArray,
                  ],
                };
              }
              // Now get items
              let itemIdsInThisItem = chosenItem.items.map((s) => s.elementId);
              let itemAlreadyIds = this.props.data.itemsNeededForSurgery.map(
                (t) => t._id
              );
              let getItemsArray = _.difference(
                itemIdsInThisItem,
                itemAlreadyIds
              );
              let itemsLoaded = await Promise.all(
                getItemsArray.map((y) => {
                  return apiCallPost(
                    `/ims2/${this.props.authStore.prefix}/item/getById`,
                    { _id: y }
                  );
                })
              ).catch((err) => {
                this.setState({ isWaitingOnLineItem: false });
                cogoToast.error(
                  "There was an error in loading the items. Please check the console for more details."
                );
                return;
              });

              if (itemsLoaded.length > 0) {
                payloadObj["itemsNeededForSurgery"] = [
                  ...this.props.data.itemsNeededForSurgery,
                  ...itemsLoaded,
                ];
              }
              // Now add line items
              payloadObj["lineItems"] = [
                ...this.props.data.lineItems,
                {
                  ...chosenItem,
                  lineItemType: "SX",
                  originalRate: -1,
                  rateChanged: false,
                  removedAfterBooking: false,
                  addedAfterBooking:
                    this.props.data.lifecycle === "DRAFT" ? false : true,
                  quantity: 1,
                },
              ];
              // Now calculate prices
              let chosen = chosenItem.payorRates.filter(
                (each) =>
                  each.branches.includes(this.props.data.site) &&
                  each.entityName === this.props.data.chosenPanelName
              );
              let chosenCash = chosenItem.cashRates.filter((each) =>
                each.branches.includes(this.props.data.site)
              );

              let currentPrice = this.props.data.totalBillAmountPaise;
              let newPrice;

              if (this.props.data.chosenPanelInfo?.isCashless === true) {
                newPrice =
                  currentPrice + (chosen[0]?.effectiveBillableRatePaise || 0);
              } else {
                newPrice = currentPrice + (chosenCash[0]?.cashRatePaise || 0);
              }
              payloadObj["lineItems"][payloadObj.lineItems.length - 1][
                "originalRate"
              ] = this.props.data.chosenPanelInfo?.isCashless
                ? chosen[0]?.effectiveBillableRatePaise || 0
                : chosenCash[0]?.cashRatePaise || 0;

              payloadObj["totalBillAmountPaise"] = newPrice;
              // payloadObj["sxPriceChart"] = chosenItem;
              this.props.onUpdate(payloadObj);
              this.setState({ isWaitingOnLineItem: false });
            }
          }}
        />
        {this.state.isWaitingOnLineItem ? <Spinner size={20} /> : null}
      </ControlGroup>
    );
  };
  renderPanelSearch = () => {
    if (this.props.data.chosenPanelId) {
      return (
        <ControlGroup>
          <Tag large minimal intent="primary">
            Payment Panel
          </Tag>
          <Tag large intent="primary">
            {this.props.data.chosenPanelName}
          </Tag>
          {this.props.data.lifecycle === "DRAFT" && (
            <Button
              outlined
              icon="edit"
              text="Edit Panel"
              onClick={() => {
                this.props.onUpdate({
                  chosenPanelId: null,
                  chosenPanelName: null,
                  patientPanelPolicyNumber: null,
                  chosenPanelInfo: null,
                });
              }}
            />
          )}
          <Tag large minimal intent="primary">
            MAID / Policy Number
          </Tag>
          <InputGroup
            value={this.props.data.patientPanelPolicyNumber}
            onChange={(event) => {
              this.props.onUpdate({
                patientPanelPolicyNumber: event.target.value,
              });
            }}
          />

          <Tag large minimal intent="primary">
            {this.props.data.chosenPanelInfo?.isCashless === true
              ? "Cashless"
              : this.props.data.chosenPanelInfo?.isCashless === false
              ? "Cash"
              : ""}
          </Tag>
        </ControlGroup>
      );
    }
    return (
      <ControlGroup>
        {this.renderAsyncSearchers(
          "Payment Panels",
          "Panels",
          "panelSearching",
          "panelSearchResults",
          "panelSelectedItem",
          "sxPaymentPanelMaster"
        )}
      </ControlGroup>
    );
  };
  renderTPASearch = () => {
    if (this.props.data.chosenTPAId) {
      return (
        <ControlGroup>
          <Tag large minimal intent="primary">
            TPA
          </Tag>
          <Tag large intent="primary">
            {this.props.data?.chosenTPAName}
          </Tag>
          {this.props.data.lifecycle === "DRAFT" && (
            <Button
              outlined
              icon="edit"
              text="Edit TPA"
              onClick={() => {
                this.props.onUpdate({
                  chosenTPAId: null,
                  chosenTPAName: null,
                });
              }}
            />
          )}
        </ControlGroup>
      );
    }
    return (
      <ControlGroup>
        {this.renderAsyncSearchers(
          "TPA Panel",
          "TPAPanels",
          "panelTPASearching",
          "panelTPASearchResults",
          "panelTPASelectedItem",
          "sxTPAMaster"
        )}
      </ControlGroup>
    );
  };
  renderLineItems = () => {
    if (!this.props.data.lineItems) {
      return null;
    }
    if (!this.props.data.lineItems.length) {
      return (
        <div>
          <Tag large intent="warning">
            No line items added yet
          </Tag>
        </div>
      );
    }
    return this.props.data.lineItems.map((lineItem, index) => {
      return <div>{this.renderEachLineItem(lineItem, index)}</div>;
    });
  };
  recalculatePrice = (ll) => {
    let newPrice = 0;
    ll.forEach((l) => {
      if (l.removedAfterBooking) {
        return;
      } else {
        if (l.lineItemType === "SX") {
          const payorRate = l.payorRates.filter(
            (each) =>
              each.branches.includes(this.props.data.site) &&
              each.entityName === this.props.data.chosenPanelName
          )[0];
          const cashRate = l.cashRates.filter((each) =>
            each.branches.includes(this.props.data.site)
          );
          newPrice += this.props.data.chosenPanelInfo?.isCashless
            ? payorRate.effectiveBillableRatePaise * l.quantity
            : cashRate[0]?.cashRatePaise * l?.quantity;
        } else if (l.lineItemType === "ANAESTHESIA") {
          l["ratePaise"] = l.hospitalCharge + l.anaesthetistFee;
          newPrice += (l.hospitalCharge + l.anaesthetistFee) * l.quantity;
        } else {
          newPrice += l.ratePaise * l.quantity;
        }
      }
    });
    return newPrice;
  };
  renderEachLineItem = (lineItem, index) => {
    return (
      <Card style={{ marginBottom: "10px", padding: "5px" }}>
        <ControlGroup vertical>
          <ControlGroup>
            <Tag
              multiline
              intent={
                lineItem.lineItemType === "SX"
                  ? "primary"
                  : lineItem.lineItemType === "ANAESTHESIA"
                  ? "success"
                  : lineItem.lineItemType === "BED"
                  ? "warning"
                  : null
              }
              large
              minimal
              icon={
                lineItem.lineItemType === "SX"
                  ? "cut"
                  : lineItem.lineItemType === "ANAESTHESIA"
                  ? "syringe"
                  : lineItem.lineItemType === "BED"
                  ? "home"
                  : null
              }
            >
              {index + 1}
            </Tag>
            <Tag
              multiline
              intent={
                lineItem.lineItemType === "SX"
                  ? "primary"
                  : lineItem.lineItemType === "ANAESTHESIA"
                  ? "success"
                  : lineItem.lineItemType === "BED"
                  ? "warning"
                  : null
              }
              large
            >
              {lineItem.lineItemType === "SX"
                ? lineItem.entityName
                : lineItem.lineItemType === "BED"
                ? `Bed: ${lineItem.ward} - Ward: ${lineItem.bed}`
                : `${lineItem.anaesthesiaType}`}
            </Tag>
            {lineItem.addedAfterBooking && (
              <Tag icon="warning-sign" intent="warning" large minimal>
                Added After Booking
              </Tag>
            )}
            {lineItem.lineItemType === "SX" ? (
              <ControlGroup>
                <Tag
                  minimal
                  large
                  intent="primary"
                  style={{ marginRight: "4px" }}
                >
                  Line Total
                </Tag>
                <Tag
                  minimal
                  large
                  intent="primary"
                  style={{ marginRight: "4px" }}
                >
                  {(() => {
                    if (this.props.data.chosenPanelInfo?.isCashless === true) {
                      if (lineItem.payorRates) {
                        const payorRate = lineItem.payorRates.filter(
                          (each) =>
                            each.branches.includes(this.props.data.site) &&
                            each.entityName === this.props.data.chosenPanelName
                        )[0];
                        return `Payor Rate: ${indianRupee(
                          payorRate.contractRateCapPaise || -1,
                          2
                        )} | Effective Billable Rate: ${indianRupee(
                          payorRate.effectiveBillableRatePaise || -1,
                          2
                        )}`;
                      } else {
                        return "NA";
                      }
                    } else {
                      if (lineItem.cashRates) {
                        const cashRate = lineItem.cashRates.filter((each) =>
                          each.branches.includes(this.props.data.site)
                        )[0]?.cashRatePaise;
                        return indianRupee(cashRate, 0);
                      } else {
                        return "NA";
                      }
                    }
                  })()}
                </Tag>
              </ControlGroup>
            ) : null}
            {lineItem.removedAfterBooking ? (
              <>
                <Tag icon="warning-sign" intent="danger" large minimal>
                  Removed After Booking
                </Tag>
              </>
            ) : (
              <Button
                outlined
                intent="danger"
                icon="trash"
                text="Remove"
                onClick={() => {
                  let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
                  if (terminals.includes(this.props.data.lifecycle)) {
                    cogoToast.error(
                      "Cannot remove line items from a discharged patient"
                    );
                    return;
                  }
                  let ll = this.props.data.lineItems;
                  let newPrice = 0;
                  if (this.props.data.lifecycle === "DRAFT") {
                    ll.splice(index, 1);
                    newPrice = this.recalculatePrice(ll);
                  } else {
                    ll[index].removedAfterBooking = true;
                    newPrice = this.recalculatePrice(ll);
                  }
                  this.props.onUpdate({
                    lineItems: ll,
                    totalBillAmountPaise: newPrice,
                  });
                  cogoToast.info(
                    "Surgery removed from the list. Please make sure to remove corresponding steps and items.",
                    { hideAfter: 10 }
                  );
                }}
              />
            )}
          </ControlGroup>
          {/* <ControlGroup>
            {lineItem.sxStepIds.length ? (
              <>
                {" "}
                <Tag multiline intent="none" large minimal>
                  Surgical Steps
                </Tag>
                <Tag multiline intent="primary" large minimal>
                  {lineItem.sxStepIds
                    .map((each) => each.elementName)
                    .join(" + ")}
                </Tag>
              </>
            ) : null}
          </ControlGroup> */}
          {/* <ControlGroup>
            {lineItem.items.length ? (
              <>
                <Tag multiline intent="none" large minimal>
                  Surgical Items
                </Tag>
                <Tag multiline intent="primary" large minimal>
                  {lineItem.items.map((each) => each.elementName).join(", ")}
                </Tag>
              </>
            ) : null}
          </ControlGroup> */}

          {lineItem.lineItemType === "SX" ? null : (
            <ControlGroup style={{ marginTop: "5px" }}>
              {" "}
              <Tag
                multiline
                intent="primary"
                large
                minimal
                style={{ marginRight: "4px" }}
              >
                Quantity
              </Tag>
              <NumericInput
                style={{ width: "4em" }}
                buttonPosition="none"
                value={lineItem.quantity}
                onValueChange={(number) => {
                  let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
                  if (terminals.includes(this.props.data.lifecycle)) {
                    cogoToast.error(
                      "Cannot change line items from a discharged patient"
                    );
                    return;
                  }
                  let ll = this.props.data.lineItems;
                  if (this.props.data.lifecycle !== "DRAFT") {
                    ll[index].qtyChangedAfterBooking = true;
                    ll[index].originalQty = ll[index].quantity;
                  }
                  ll[index].quantity = number;
                  let newPrice = this.recalculatePrice(ll);
                  this.props.onUpdate({
                    lineItems: ll,
                    totalBillAmountPaise: newPrice,
                  });
                }}
              />
              <Tag
                multiline
                intent="primary"
                large
                minimal
                style={{ marginRight: "4px" }}
              >
                Rate
              </Tag>
              <Tag
                multiline
                intent={
                  this.props.data.chosenPanelInfo?.isCashless
                    ? "danger"
                    : "success"
                }
                large
                minimal
                style={{ marginRight: "4px" }}
              >
                {this.props.data.chosenPanelInfo?.isCashless
                  ? "Cashless"
                  : "Cash"}
              </Tag>
              {lineItem.lineItemType === "ANAESTHESIA" ? (
                <>
                  <Tag
                    multiline
                    intent={
                      this.props.data.chosenPanelInfo?.isCashless
                        ? "danger"
                        : "success"
                    }
                    large
                    minimal
                  >
                    Hospital Charge
                  </Tag>
                  <NumericInput
                    style={{ width: "7em" }}
                    rightElement={<Tag minimal>₹</Tag>}
                    buttonPosition="none"
                    value={lineItem.hospitalCharge / 100}
                    onValueChange={(number) => {
                      let terminals = [
                        "DISCHARGED",
                        "LAMA",
                        "DEATH",
                        "CANCELLED",
                      ];
                      if (terminals.includes(this.props.data.lifecycle)) {
                        cogoToast.error(
                          "Cannot change line items from a discharged patient"
                        );
                        return;
                      }
                      let ll = this.props.data.lineItems;
                      ll[index].hospitalCharge = number * 100;
                      // if (number * 100 !== ll[index].originalRate) {
                      //   ll[index].rateChanged = true;
                      // } else {
                      //   ll[index].rateChanged = false;
                      // }
                      let newPrice = this.recalculatePrice(ll);
                      this.props.onUpdate({
                        lineItems: ll,
                        totalBillAmountPaise: newPrice,
                      });
                    }}
                  />
                  <Tag
                    multiline
                    intent={
                      this.props.data.chosenPanelInfo?.isCashless
                        ? "danger"
                        : "success"
                    }
                    large
                    minimal
                  >
                    Anaesthetist Fee
                  </Tag>
                  <NumericInput
                    style={{ width: "7em" }}
                    rightElement={<Tag minimal>₹</Tag>}
                    buttonPosition="none"
                    value={lineItem.anaesthetistFee / 100}
                    onValueChange={(number) => {
                      let terminals = [
                        "DISCHARGED",
                        "LAMA",
                        "DEATH",
                        "CANCELLED",
                      ];
                      if (terminals.includes(this.props.data.lifecycle)) {
                        cogoToast.error(
                          "Cannot change line items from a discharged patient"
                        );
                        return;
                      }
                      let ll = this.props.data.lineItems;
                      ll[index].anaesthetistFee = number * 100;
                      // if (number * 100 !== ll[index].originalRate) {
                      //   ll[index].rateChanged = true;
                      // } else {
                      //   ll[index].rateChanged = false;
                      // }
                      let newPrice = this.recalculatePrice(ll);
                      this.props.onUpdate({
                        lineItems: ll,
                        totalBillAmountPaise: newPrice,
                      });
                    }}
                  />
                </>
              ) : null}
              {lineItem.lineItemType === "ANAESTHESIA" ? null : (
                <NumericInput
                  style={{ width: "7em" }}
                  rightElement={<Tag minimal>₹</Tag>}
                  buttonPosition="none"
                  value={lineItem.ratePaise / 100}
                  onValueChange={(number) => {
                    let terminals = [
                      "DISCHARGED",
                      "LAMA",
                      "DEATH",
                      "CANCELLED",
                    ];
                    if (terminals.includes(this.props.data.lifecycle)) {
                      cogoToast.error(
                        "Cannot change line items from a discharged patient"
                      );
                      return;
                    }
                    let ll = this.props.data.lineItems;
                    ll[index].ratePaise = number * 100;
                    if (number * 100 !== ll[index].originalRate) {
                      ll[index].rateChanged = true;
                    } else {
                      ll[index].rateChanged = false;
                    }
                    let newPrice = this.recalculatePrice(ll);
                    this.props.onUpdate({
                      lineItems: ll,
                      totalBillAmountPaise: newPrice,
                    });
                  }}
                />
              )}
              {lineItem.qtyChangedAfterBooking ? (
                <Tag intent="danger" large minimal>
                  Quantity Changed After Booking, Originally{" "}
                  {lineItem.originalQty}
                </Tag>
              ) : null}
              {lineItem.rateChanged ? (
                <Tag intent="danger" large minimal>
                  Rate Changed, Originally{" "}
                  {indianRupee(lineItem.originalRate, 0)}
                </Tag>
              ) : null}
              <Tag
                minimal
                large
                intent="primary"
                style={{ marginRight: "4px" }}
              >
                Line Total
              </Tag>
              <Tag
                minimal
                large
                intent="primary"
                style={{ marginRight: "4px" }}
              >
                {indianRupee(lineItem.quantity * lineItem.ratePaise, 0)}
              </Tag>
            </ControlGroup>
          )}
        </ControlGroup>
      </Card>
    );
  };
  renderLineItemSearch = () => {
    let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
    if (terminals.includes(this.props.data.lifecycle)) {
      return null;
    }
    return (
      <ControlGroup>
        {this.renderAsyncSearchers(
          "Add Surgical Line Items",
          "Surgeries",
          "sxLineItemSearching",
          "sxLineItemSearchResults",
          "sxLineItemSelectedItem",
          "sxPriceMaster"
        )}
      </ControlGroup>
    );
  };
  renderTotalCost = () => {
    return (
      <ControlGroup>
        <Tag intent="success" minimal large>
          Total Cost
        </Tag>
        <Tag intent="success" large>
          {/* {indianRupee(this.props.data.totalBillAmountPaise, 0)} */}
          {indianRupee(this.recalculatePrice(this.props.data.lineItems), 2)}
        </Tag>
      </ControlGroup>
    );
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <ControlGroup style={{ marginBottom: "10px" }}>
              {" "}
              <Tag large intent="primary">
                Surgery Billing Line Items
              </Tag>
              <Tag large minimal>
                Chosen Panel: {this.props.data.chosenPanelName}
              </Tag>
              <Tag large minimal>
                Chosen TPA: {this.props.data?.chosenTPAName}
              </Tag>
              <Tag large minimal>
                {this.props.data.lineItems
                  .map((each) => {
                    if (each.lineItemType === "SX") {
                      return each.entityName;
                    } else if (each.lineItemType === "ANAESTHESIA") {
                      return each.anaesthesiaType;
                    } else {
                      return `Ward:${each.bed} - ${each.ward}`;
                    }
                  })
                  .join(" + ")}
              </Tag>{" "}
              <Tag large minimal>
                Total:{" "}
                {indianRupee(
                  this.recalculatePrice(this.props.data.lineItems),
                  2
                )}
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: false })}
              />
            </ControlGroup>
          </Card>
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large intent="primary" fill>
                Surgery Billing Line Items
              </Tag>{" "}
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <br />
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <ControlGroup style={{ marginBottom: "5px" }}>
                {this.renderPanelSearch()}
              </ControlGroup>
              <ControlGroup style={{ marginBottom: "5px" }}>
                {this.renderTPASearch()}
              </ControlGroup>
              <ControlGroup style={{ marginBottom: "1px" }}>
                {this.renderLineItemSearch()}
              </ControlGroup>
              <ControlGroup
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {this.renderLineItems()}
              </ControlGroup>

              <ControlGroup style={{ marginBottom: "5px" }}>
                {this.renderChooseAnaesthesiaType()}
              </ControlGroup>

              <ControlGroup style={{ marginBottom: "5px" }}>
                {this.renderChooseBedWardType()}
              </ControlGroup>
              <ControlGroup style={{ marginBottom: "5px" }}>
                {this.renderTotalCost()}
              </ControlGroup>
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  renderChooseAnaesthesiaType = () => {
    let ss = this.props.data.lineItems;
    let anIdx = _.findIndex(ss, (each) => each.lineItemType === "ANAESTHESIA");
    if (anIdx > -1) {
      return null;
    } else {
      let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
      if (terminals.includes(this.props.data.lifecycle)) {
        return null;
      }
      return (
        <ControlGroup>
          {this.renderAsyncSearchers(
            "Choose Anaesthesia Type",
            "Anaesthesia",
            "anSearching",
            "anSearchResults",
            "anSelectedItem",
            "sxAnaesthesiaPriceMaster"
          )}
        </ControlGroup>
      );
    }
  };
  renderChooseBedWardType = () => {
    let ss = this.props.data.lineItems;
    let anIdx = _.findIndex(ss, (each) => each.lineItemType === "BED");
    if (anIdx > -1) {
      return null;
    } else {
      let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
      if (terminals.includes(this.props.data.lifecycle)) {
        return null;
      }
      return (
        <ControlGroup>
          {this.renderAsyncSearchers(
            "Choose Bed/Ward Type",
            "Bed/Ward",
            "bedSearching",
            "bedSearchResults",
            "bedSelectedItem",
            "sxBedMaster"
          )}
        </ControlGroup>
      );
    }
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxLineItems)));
